import { Dispatch, SetStateAction, useState } from "react"

type SetPartialStateAction<S> = Partial<S> | ((prevState: S) => Partial<S>)

export default function usePartialState<S>(
  initialState: S | (() => S)
): [S, Dispatch<SetStateAction<S>>, Dispatch<SetPartialStateAction<S>>] {
  const [state, setState] = useState(initialState)
  function setPartialState(argument: SetPartialStateAction<S>) {
    if (typeof argument === "function") {
      setState((prev) => {
        const partial = argument(prev)
        return {
          ...prev,
          ...partial,
        }
      })
    } else {
      setState((prev) => ({
        ...prev,
        ...argument,
      }))
    }
  }

  return [state, setState, setPartialState]
}
